import React from "react";

//Components
import { Button, Typography } from "@material-ui/core";
import { Control, Form } from "react-redux-form";
import { withStyles } from "@material-ui/core/styles";

//Deps
import { validate } from "./../util";

//Styles
const styles = theme => ({
  root: {},
  button: {
    padding: "1em"
  },
  typography: {
    paddingBottom: "2em"
  }
});

const LoginForm = props => {
  const {
    classes,
    model,

    //Form Values
    email,
    password,
    dbErrors,

    //Form State
    formIsValid,
    pending,

    //Dispatches
    resetPasswordDispatch
  } = props;

  const resetPassword = () => {
    resetPasswordDispatch(email);
  };

  return (
    <Form model={`${model}`} onSubmit={val => props.handleSubmit(val)} validators={validate.loginFormRules(email, password, dbErrors)}>
      <div className="group">
        <Control.text model={`${model}.email`} type="email" validators={validate.emailRules(email)} required />
        <span className="highlight" />
        <span className="bar" />
        <label>email</label>
      </div>

      <div className="group">
        <Control.text model={`${model}.password`} type="password" required />
        <span className="highlight" />
        <span className="bar" />
        <label>password</label>
      </div>
      {dbErrors === "incorrectPassword" ? (
        <div>
          <Typography align="center" className={classes.typography} onClick={resetPassword}>
            incorrect password
          </Typography>
          <Typography align="center" className={classes.typography} onClick={resetPassword}>
            send password reset to {email}
          </Typography>
        </div>
      ) : null}
      <Button type="submit" variant="raised" color="primary" fullWidth={true} disabled={!formIsValid || pending} className={classes.button}>
        submit
      </Button>
    </Form>
  );
};

export default withStyles(styles)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/LoginForm.js